module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.compyinfo) ? _c('div', [_c('div', {
    staticClass: "flex align-start m-b-15"
  }, [_c('div', {
    staticClass: "flex-grow flex flex-column align-initial"
  }, [_c('div', {
    staticClass: "search-cont com-model m-b-15"
  }, [_c('input', {
    staticStyle: {
      "display": "none",
      "opacity": "0",
      "height": "0",
      "padding": "0"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "search-box m-b-16",
    staticStyle: {
      "width": "calc(100% - 4px)"
    },
    attrs: {
      "placeholder": "请输入岗位名搜索全网人才",
      "autocomplete": "off"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.search($event)
      }
    },
    model: {
      value: (_vm.searchWord),
      callback: function($$v) {
        _vm.searchWord = $$v
      },
      expression: "searchWord"
    }
  }, [_c('i', {
    staticClass: "el-icon-search",
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.search(_vm.searchWord)
      }
    },
    slot: "append"
  }, [_vm._v("搜人才")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-between"
  }, [_c('div', {
    staticClass: "flex flex-grow",
    staticStyle: {
      "flex-shrink": "1",
      "overflow": "hidden",
      "margin-right": "30px"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("热门搜索")]), _vm._v(" "), _vm._l((_vm.hotwordList), function(item, index) {
    return [(index < 3) ? _c('div', {
      key: index,
      staticClass: "ls-item",
      on: {
        "click": function($event) {
          _vm.search(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.value))]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex flex-shrink"
  }, [_c('div', {
    staticClass: "tip  flex-shrink"
  }, [_vm._v("希望主动求职者投递？")]), _vm._v(" "), _c('router-link', {
    staticClass: "out-line",
    attrs: {
      "to": "/index/posts/release",
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("发布岗位\n            ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "compy-info com-model"
  }, [_c('div', {
    staticClass: "top flex flex-between align-start m-b-15"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "compy-logo flex flex-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.compyinfo.logo,
      "alt": "公司头像"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-between align-initial"
  }, [_c('div', [_c('div', {
    staticClass: "top-title flex m-b-10"
  }, [_c('div', {
    staticClass: "m-r-16"
  }, [_vm._v(_vm._s(_vm.compyinfo.name))]), _vm._v(" "), (_vm.compyinfo.isAuth === 2) ? _c('div', {
    staticClass: "auth-ing"
  }, [_vm._v("认证中")]) : (_vm.compyinfo.isAuth === 0) ? _c('router-link', {
    staticClass: "no-auth flex flex-center",
    attrs: {
      "to": "/index/company/auth"
    }
  }, [_vm._v("\n                    立即认证\n                    "), _c('img', {
    staticStyle: {
      "width": "18px",
      "height": "18px",
      "margin-left": "5px"
    },
    attrs: {
      "src": require("../../assets/images/home/renzhen_icon.png"),
      "alt": ""
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-between m-b-16"
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-right": "70px"
    }
  }, [_c('div', {
    staticClass: "appraise-tit"
  }, [_vm._v("用户综合评分：")]), _vm._v(" "), _c('star-temp', {
    staticClass: "startemp",
    attrs: {
      "star-num": _vm.$store.state.hrinfo.fullEval
    }
  })], 1), _vm._v(" "), (_vm.$store.state.hrinfo.fullEval) ? _c('router-link', {
    staticClass: "flex flex-end appraise-see",
    attrs: {
      "to": "/index/home/valuation"
    }
  }, [_vm._v("\n                    查看评分"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _c('div', {
    staticClass: "appraise-see"
  }, [_vm._v("暂无评价")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [(_vm.compyinfo.isVip) ? _c('img', {
    staticClass: "m-r-30",
    staticStyle: {
      "width": "44px",
      "height": "31px"
    },
    attrs: {
      "src": require("../../assets/images/home/vip_icon.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.compyinfo.isAuth === 1) ? _c('img', {
    staticClass: "m-r-30",
    staticStyle: {
      "width": "44px",
      "height": "33px"
    },
    attrs: {
      "src": require("../../assets/images/home/renzhened_icon.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.compyinfo.isVip) ? _c('router-link', {
    staticClass: "go-vip flex flex-between",
    attrs: {
      "to": {
        path: '/index/member/info'
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../../assets/images/home/vip_word_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v("尚未开通会员，点击去开通可享受会员权益。")])]), _vm._v(" "), _c('div', {
    staticClass: "go"
  }, [_vm._v("去开通 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "130px"
    }
  }, [_c('div', {
    staticClass: "word-show"
  }, [_vm._v("信息完善度：" + _vm._s(_vm.compyinfo.perfectRate * 100) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      width: _vm.compyinfo.perfectRate * 100 + '%'
    })
  })])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-bottom": "9px"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("我的余额：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.availableFunds) + "点")]), _vm._v(" "), _c('div', {
    staticClass: "uinfo-b-btn",
    on: {
      "click": _vm.gorecharge
    }
  }, [_vm._v("充值")]), _vm._v(" "), _c('div', {
    staticClass: "uinfo-b-btn",
    on: {
      "click": function($event) {
        _vm.gofinance(1)
      }
    }
  }, [_vm._v("明细")])]), _vm._v(" "), (_vm.compyinfo.isVip) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("会员到期时间：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.vipEnd.split(" ")[0]))]), _vm._v(" "), _c('div', {
    staticClass: "uinfo-b-btn",
    on: {
      "click": _vm.gomember
    }
  }, [_vm._v("续费")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "notice-list com-model"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('router-link', {
    staticClass: "look-more",
    attrs: {
      "to": {
        path: '/index/home/notice'
      }
    }
  }, [_vm._v("查看全部")]), _vm._v(" "), _c('div', {
    staticClass: "carousel",
    attrs: {
      "id": "scrollContainer"
    }
  }, [_vm._l((_vm.noticeList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "notice-item"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createdAt.split(' ')[0]))])])
  }), _vm._v(" "), _c('img', {
    staticClass: "manager-img",
    attrs: {
      "src": _vm.compyinfo.bizCard,
      "alt": ""
    }
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "com-model data-show m-b-15"
  }, [_c('div', {
    staticClass: "line-title m-b-22"
  }, [_vm._v("数据概况")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-between list-cont"
  }, [_c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("待处理简历")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.waitHandleResume))]), _vm._v(" "), _c('div', {
    staticClass: "last flex"
  }, [_vm._v("已收简历： " + _vm._s(_vm.compyinfo.totalResume) + "份")]), _vm._v(" "), _c('router-link', {
    staticClass: "go-more flex",
    attrs: {
      "to": {
        path: '/index/resume/list'
      }
    }
  }, [_vm._v("前往处理\n          "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../../assets/images/home/go_to_blue_icon.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("招聘中的岗位")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.recruitNum))]), _vm._v(" "), _c('div', {
    staticClass: "last flex"
  }, [_vm._v("剩余发布岗位数： " + _vm._s(_vm.compyinfo.remainRecruitNum) + "个")]), _vm._v(" "), _c('router-link', {
    staticClass: "go-more flex",
    attrs: {
      "to": {
        path: '/index/posts/list'
      }
    }
  }, [_vm._v("详情\n          "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../../assets/images/home/go_to_blue_icon.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("已下载简历")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.collNum))]), _vm._v(" "), _c('div', {
    staticClass: "last flex"
  }, [_vm._v("剩余下载简历次数： " + _vm._s(_vm.compyinfo.remainCollNum) + "次")]), _vm._v(" "), _c('router-link', {
    staticClass: "go-more flex",
    attrs: {
      "to": {
        path: '/index/resume/list'
      }
    }
  }, [_vm._v("\n          前往处理\n          "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../../assets/images/home/go_to_blue_icon.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("已收藏简历")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.compyinfo.favoriteNum))]), _vm._v(" "), _c('div', {
    staticClass: "last flex"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "go-more flex",
    attrs: {
      "to": {
        path: '/index/resume/list',
        query: {
          index: 6
        }
      }
    }
  }, [_vm._v("\n          前往处理\n          "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../../assets/images/home/go_to_blue_icon.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("赴外招聘记录")]), _vm._v(" "), _c('div', {
    staticClass: "value qr-img",
    on: {
      "click": _vm.toRecruitmentRecord
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.compyinfo.qrAbroadCode,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "last flex"
  }, [_vm._v("待处理： " + _vm._s(_vm.compyinfo.abroadNum || 0) + "份")]), _vm._v(" "), _c('router-link', {
    staticClass: "go-more flex",
    attrs: {
      "to": {
        path: '/index/resume/list'
      }
    }
  }, [_vm._v("\n          前往处理\n          "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-left": "8px"
    },
    attrs: {
      "src": require("../../assets/images/home/go_to_blue_icon.png"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-item yellow-bg"
  }, [_c('div', {
    staticClass: "label flex flex-wrap"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('router-link', {
    staticClass: "red-btn",
    attrs: {
      "to": {
        path: '/index/member/info'
      }
    }
  }, [_vm._v("去开通/续费")])], 1), _vm._v(" "), _c('div', {
    staticClass: "line-item flex"
  }, [_c('div', {
    staticClass: "line-label"
  }, [_vm._v("剩余可下载：")]), _vm._v(" "), _c('div', {
    staticClass: "line-value"
  }, [_vm._v(_vm._s(_vm.compyinfo.remainCollNum) + "次")])]), _vm._v(" "), _c('div', {
    staticClass: "line-item flex"
  }, [_c('div', {
    staticClass: "line-label"
  }, [_vm._v("剩余可招聘：")]), _vm._v(" "), _c('div', {
    staticClass: "line-value"
  }, [_vm._v(_vm._s(_vm.compyinfo.remainRecruitNum) + "次")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "com-model relative",
    staticStyle: {
      "padding-top": "14px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "line-title m-b-30"
  }, [_vm._v("活动")]), _vm._v(" "), _c('router-link', {
    staticClass: "look-more",
    attrs: {
      "to": {
        path: '/index/jobfair'
      }
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
    staticClass: "activity-list"
  }, _vm._l((_vm.zphList), function(item) {
    return _c('activity-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.imageVisible),
      callback: function($$v) {
        _vm.imageVisible = $$v
      },
      expression: "imageVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-title flex m-b-15"
  }, [_vm._v("\n        公告通知\n        "), _c('img', {
    staticStyle: {
      "width": "18px",
      "height": "18px",
      "margin-left": "4px"
    },
    attrs: {
      "src": require("../../assets/images/home/notice_icon.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex align-start"
  }, [_c('img', {
    staticStyle: {
      "width": "27px",
      "height": "19px",
      "margin-right": "7px"
    },
    attrs: {
      "src": require("../../assets/images/home/vip_icon.png"),
      "alt": ""
    }
  }), _vm._v("\n            会员特权\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dee061f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = 918
// module chunks = 1